module.exports = __webpack_public_path__ + "static/media/PIWI.20b6b02f.md";